import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
// import Step9HeightSelection from 'src/components/SignupSteps/CreateSignUp/Step9HeightSelection';
// import Step4WorkField from 'src/components/SignupSteps/ProfileModal/Step4WorkField';
// import Step8Location from 'src/components/SignupSteps/CreateSignUp/Step8Location';
// import Step2RelationshipStatus from 'src/components/SignupSteps/ProfileModal/Step2RelationshipStatus';
// import Step5InterestedInSelection from 'src/components/SignupSteps/CreateSignUp/Step5InterestedInSelection';
// import Step6NetWorth from 'src/components/SignupSteps/ProfileModal/Step6NetWorth';
// import Step4GenderSelection from 'src/components/SignupSteps/CreateSignUp/Step4GenderSelection';

import Step9HeightSelection from './Step9HeightSelection';
import UserInfoRow from './UserInfoRow';
import Step2RelationshipStatus from './Step2RelationshipStatus';
import Step5InterestedInSelection from './Step5InterestedInSelection';
import Step4GenderSelection from './Step4GenderSelection';
import Step4WorkField from './Step4WorkField';
import Step8Location from './Step8Location';
import { convertHeightInScale } from '../../../utils/CommonUtils';


const IMAGE_BASE_PATH = '/assets/images/user-profile/';

const UserInfoSection = ({ memberData, isEditBtn = true, fieldsToShow = null, className, classflexinBlock }) => {

  const [selectedField, setSelectedField] = useState(null);
  const [formData, setFormData] = useState(memberData);
  const Height = convertHeightInScale(memberData?.tall);
  if (!memberData) {
    return null;
  }
  const user = {
    height: Height,
    relationship: (memberData?.relationship ?? memberData.currentRelationshipStatus) || '',
    relationshipGoal: memberData.relationshipGoal || '',
    interested: memberData.preferences?.gender,//'Woman',
    bodyType: memberData.bodyType || '',
    gender: memberData.gender,
    workField: memberData.workField || '',
    location: (memberData.lastLocation) ? memberData.lastLocation.city + ',' + memberData.lastLocation.country : memberData?.city + ',' + memberData?.country
  };
  const handleUpdate = (field, value) => {

  };

  const infoList = [
    {
      icon: 'height.svg',
      label: 'Height',
      value: user.height,
      Component: (
        <Step9HeightSelection
          showHeader={false}
          className="pt-pb-0"
          formData={{ height: user.height }}
          setFormData={(data) => handleUpdate('height', data.height)}
          onNext={() => setSelectedField(null)}
          onBack={() => setSelectedField(null)}
        />
      ),
    },
    {
      icon: 'relationship.svg',
      label: 'Relationship',
      value: user?.relationship,
      Component: (
      <></>
      ),
    },
    {
      icon: 'who-are-you.svg',
      label: 'Who are you interested in',
      value: user.interested,
      Component: <Step5InterestedInSelection className="pt-pb-0" showHeader={false} />,
    },
    {
      icon: 'gender.svg',
      label: 'Gender',
      value: user.gender,
      Component: (
        <Step4GenderSelection
          className="pt-pb-0"
          value={user.gender}
          onChange={(val) => handleUpdate('gender', val)}
          showHeader={false}
        />
      ),
    },
    {
      icon: 'occupation.svg',
      label: 'Occupation',
      value: user.workField,
      Component: (
        <Step4WorkField
          className="pt-pb"
          showHeader={false}
          value={user.workField}
          onChange={(val) => handleUpdate('workField', val)}
        />
      ),
    },
    {
    icon: 'body-type.svg',
    label: 'Body Type',
    value: user?.bodyType,
    Component:<></>,
  },
  {
    icon: 'intent-icon.svg',
    label: 'Intent',
    value: user?.relationshipGoal,
    Component:<></>,

  },
    {
      icon: 'location.svg',
      label: 'Location',
      value: user.location,
      Component: (
        <Step8Location
          className="pt-pb-0"
          showHeader={false}
          value={user.location}
          onChange={(val) => handleUpdate('location', val)}
        />
      ),
    },
  ];

  // 🔍 Filter logic
  const filteredInfoList = fieldsToShow
    ? infoList.filter((item) => fieldsToShow.includes(item.label))
    : infoList;

  return (
    <Box className={className}
      sx={{
        backgroundColor: '#FFFFFF',
        padding: { xs: '16px 16px', sm: '16px', lg: '24px 20px' },
        borderRadius: 2,
        my: { xs: '0', sm: '20px' },
      }}
    >
      <Typography
        className="FontIvypresto"
        fontWeight={600}
        sx={{ fontSize: { xs: '20px', sm: '20px' }, mb: 2, color: '#6A513E' }}
      >
        General Info
      </Typography>

      {filteredInfoList.map(({ icon, label, value, Component }) => (
        <UserInfoRow
          key={label}
          icon={<img src={`${IMAGE_BASE_PATH}${icon}`} alt={label} className="img-fluid" />}
          label={label}
          value={value}
          onEdit={() => setSelectedField({ label, Component })}
          isEditBtn={isEditBtn}
          classflexinBlock={classflexinBlock}
        />
      ))}


    </Box>
  );
};


export default UserInfoSection;
